
import { Types } from "../actions/actionTypes";

let initialState = {
    wardData: {}
}

export const wardDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.WARD_DATA:
            {
                let selectedWard = action.payload.selectedWard;
                let wardId = action.payload.id;
                let data = action.payload.data;

                let wData = state.wardData;
                wData[wardId] = data;
                wData["selectedWard"] = selectedWard;

                return {
                    ...state,
                    wardData: { ...wData }
                };
            }
        case Types.SELECTED_WARD:
            {
                const selectedWard = action.payload;
                return {
                    ...state,
                    selectedWard: selectedWard,
                }
            }
        default:
            return state;
    }
}